import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {

    // 查询列表数据
    findAll({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`courseProgress/getPage`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
    exportCourseProgressDown({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`courseProgress/exportCourseProgressDown`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
    // 导出数据
    expotrtTable({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`deptArea/findById`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
    // 获取大区下拉数据
    getAreaList({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.post(`deptArea/findById`, params)
                .then(response => {
                resolve(response)
                })
                .catch(error => {
                reject(error)
            })
        })
    },
};
